import printJS from 'print-js'
import ReactModal from 'react-modal';
import { Trans } from 'react-i18next';

import '../../App.css';
import Icon from '../Icons/Icon';

const Rules = (props) => {
    const padding = 24; // adjust this to your needs
    let height = (600 + padding);
    let heightPx = height + 'px';
    let heightOffset = height / 2;
    let offsetPx = heightOffset + 'px';

    const style = {
      content: {
        border: '0',
        borderRadius: '4px',
        bottom: 'auto',
        height: heightPx,  // set height
        left: '50%',
        padding: '1rem',
        position: 'fixed',
        right: 'auto',
        top: '50%', // start from center
        transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
        width: '80%',
        maxWidth: '40rem',
        overflow: 'hidden'
      }
    };

    return (
        <ReactModal isOpen={props.isOpen} onRequestClose={props.closeModal} style={style} > {/*portalClassName="rrm-small"*/}
            <div className="contact-modal-container" style={{maxHeight: heightPx, overflowY: 'scroll', width: '96%'}}>
                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                    <div style={{display: 'flex', flexDirection: 'row', flex: 1, maxHeight: 24}}>
                        <div className="modal-header-icon" style={{flex: 1, justifyContent: 'center'}}>
                            {/* <Icon name="SuccessForm" size={64} style={{color: colours.validate_green}}/> */}
                        </div>
                        <div className="modal-close-icon" onClick={props.closeModal}>
                            <Icon name="Close" size={20} />
                        </div>
                    </div>
                    <div className="H5">
                        <Trans>Contest Rules</Trans>
                    </div>
                    <div className="P2" id="terms-text" style={{marginTop: 16}}>
                        <div className="P2" style={{marginBottom: 16}}>
                            <Trans i18nKey="rules-1">Sponsored and administered by Subaru Canada Inc. Entry opens on May 2, 2022 at 12:01 a.m. EST and ends on June 30, 2022 at 11:59 p.m. EST.</Trans>
                        </div>
                        <div className="P2" style={{marginBottom: 16}}>
                            <Trans>Open to legal residents of Canada who have reached the age of majority.</Trans>
                        </div>
                        <div className="P2" style={{marginBottom: 16}}>
                            <Trans i18nKey="rules-2">Entrant must submit a photo taken in a Canadian national or provincial park at www.adventureoncontest.ca or www.concoursenavantlaventure.ca. One entry per individual per day. Entries must: (a) comply with all Contest Rules;(b) be the original work of the Entrant; (c) not have been previously published, used commercially, submitted prior to this Contest or during this Contest to another competition or promotion or won previous awards; and (d) must not infringe upon the copyrights, trademarks, rights of privacy, publicity or other intellectual property or other rights of any person or entity.</Trans>
                        </div>
                        <div className="P2" style={{marginBottom: 16}}>
                            <Trans>Each Entrant grant the Sponsor a non-exclusive, unlimited, royalty free and irrevocable right and license to use, publish, display, produce, perform, convert, adapt, publicly present, communicate to the public, assign, sub-license, edit, modify, translate, reproduce, dispose of, post, broadcast or otherwise use their Entry, including their likeness (such as their name, face, voice or any other personal representations), in whole or in part, in any way and in any form of media now known or hereafter developed, including, without limitation, in any of Sponsor’s advertising, marketing or publicity, without review, notice, approval or compensation.</Trans>
                        </div>
                        <div className="P2" style={{marginBottom: 16}}>
                            <Trans i18nKey="rules-3">Entrants waive any moral rights they may have or claim in relation to their Entries in favour of Sponsor.  One (1) Grand Prize $11,485 approximate retail value consisting of: Cannondale Moterra Neo 3 Mountain e-Bike:  Up to 12-months for delivery, Thule Tepui Ayer 2 Tent, Chilly Moose 35L The Moose Fridge Freezer, Chilly Moose 55L Chilly Ice Box, Parks Canada Family/Group Discovery Pass, Thule EnRoute Backpack 23L, Chilly Moose 64oz Big Pine Canteen; Four (4) Second Prizes $3,135 approximate retail value each, consisting of:  Chilly Moose 35L The Moose Fridge Freeze, Thule Bike Rack maximum value of $600 or Thule Gift Card, MEC Gift Card, Chilly Moose 55L Chilly Ice Box, Parks Canada/Family Group Discovery Pass, Thule EnRoute Backpack 23L, Chilly Moose 64oz Big Pine Canteen; Twenty (20) Third Prizes $317 approximate retail value each, consisting of:  Parks Canada/Family Group Discovery Pass, Thule EnRoute Backpack 23L, Chilly Moose 64oz Big Pine Canteen. Prize winners selected on July 7, 2022. Odds of winning the Prize depends on the number of eligible entries submitted during the Contest Period and on being selected by Panel against judging criteria.</Trans>
                        </div>
                    </div>
                    <div className="two-button-container">
                        <div className="contact-modal-cancel-button" onClick={()=>{printJS({printable: 'terms-text', type: 'html', header: 'Terms and Conditions'})}}>
                            <Icon name="Printer" size={20} style={{marginRight: 10}}/>
                            <Trans>Print</Trans>
                        </div>
                        <div className="contact-modal-cancel-button" onClick={props.closeModal} style={{marginRight: 0}}>
                            <Trans>Close</Trans>
                        </div>
                    </div>
                </div>
            </div>
        </ReactModal>
    )
 }

 export default Rules;